var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicMicOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24882 12.8301C9.57769 12.4574 9.54214 11.8887 9.16943 11.5598C8.79672 11.2309 8.22798 11.2665 7.89911 11.6392L3.92057 16.1482C2.86233 17.3475 2.91901 19.163 4.05 20.294C5.18098 21.4249 6.99641 21.4816 8.19574 20.4234L12.7041 16.4454C13.0768 16.1165 13.1124 15.5478 12.7835 15.1751C12.4546 14.8024 11.8859 14.7668 11.5132 15.0957L7.00482 19.0737C6.51822 19.503 5.78166 19.48 5.32279 19.0212C4.86392 18.5623 4.84092 17.8257 5.27027 17.3391L9.24882 12.8301Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1001 12.3C18.4197 12.3 20.3001 10.4196 20.3001 8.09996C20.3001 5.78037 18.4197 3.89996 16.1001 3.89996C13.7805 3.89996 11.9001 5.78037 11.9001 8.09996C11.9001 10.4196 13.7805 12.3 16.1001 12.3ZM16.1001 14.1C19.4138 14.1 22.1001 11.4137 22.1001 8.09996C22.1001 4.78626 19.4138 2.09996 16.1001 2.09996C12.7864 2.09996 10.1001 4.78626 10.1001 8.09996C10.1001 11.4137 12.7864 14.1 16.1001 14.1Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicMicOutline);
export default __webpack_public_path__ + "static/media/music_mic_outline.202e8d9ba65687961e6deed81674f558.svg";
export { ForwardRef as ReactComponent };